import { render } from "./RequestKeyPage.vue?vue&type=template&id=d8a4bfa0&scoped=true&ts=true"
import script from "./RequestKeyPage.vue?vue&type=script&lang=ts"
export * from "./RequestKeyPage.vue?vue&type=script&lang=ts"

import "./RequestKeyPage.vue?vue&type=style&index=0&id=d8a4bfa0&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8a4bfa0"]])

export default __exports__